import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Guard that checks if a given select is true in the store.
 * Dispatches actions if given.
 */
export class StoreSelectGuard {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(
      select(next.data.select),
      map(isSelected => {
        if (!isSelected) {
          return this.router.parseUrl('/');
        }

        if (next.data.actions) {
          next.data.actions.forEach(action => {
            this.store.dispatch(action());
          });
        }
        return true;
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next);
  }
}
